/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import styled from 'styled-components';
import { FormProvider, useForm } from 'react-hook-form';
import useAsyncAction from '../../../commonComponents/Hooks';
import { tabletPortraitMinWidth } from '../../cssConstants';
import FormButton from './FormButton';

const AppForm = ({
	children,
	methods,
	defaultValues,
	onSubmit: handleSubmission,
	onBackButtonClick,
	primaryButtonText = 'Continue',
	secondaryButtonText = 'Back',
	singleColumn = true,
	validateOnChange = false,
	readOnly = false,
	hideButtons = false,
	buttonPaddingTop,
	formButtonRef,
	className = ''
}: Props) => {
	const performAsyncAction = useAsyncAction();

	const formMethods = methods ?? useForm({ defaultValues, mode: validateOnChange ? 'onChange' : 'onSubmit' });
	const { reset, handleSubmit } = formMethods;

	const submitData = async (data: unknown) => {
		await performAsyncAction(async () => {
			await handleSubmission(data);
			if (defaultValues) reset(defaultValues);
		});
	};

	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<FormProvider {...formMethods}>
			<StyledForm
				onSubmit={!readOnly ? handleSubmit(submitData) : null}
				$singleColumn={singleColumn}
				className={className}
			>
				{children}
				{!readOnly && !hideButtons && (
					<FormButton
						formButtonRef={formButtonRef}
						buttonPaddingTop={buttonPaddingTop}
						onOtherButtonClick={onBackButtonClick}
						otherButtonText={secondaryButtonText}
						continueButtonText={primaryButtonText}
					/>
				)}
				{readOnly && !hideButtons && (
					<FormButton
						formButtonRef={formButtonRef}
						buttonPaddingTop={buttonPaddingTop}
						onOtherButtonClick={onBackButtonClick}
						otherButtonText={secondaryButtonText}
						continueButtonText={primaryButtonText}
						disabled
					/>
				)}
			</StyledForm>
		</FormProvider>
	);
};

export default AppForm;

interface Props {
	children: React.ReactNode;
	defaultValues?: unknown;
	methods?: any;
	onSubmit?: (data: unknown) => Promise<void> | void;
	onBackButtonClick?: () => void;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	singleColumn?: boolean;
	validateOnChange?: boolean;
	readOnly?: boolean;
	hideButtons?: boolean;
	buttonPaddingTop?: string;
	formButtonRef?: React.Ref<HTMLElement>;
	className?: string;
}

const StyledForm = styled.form<{ $singleColumn: boolean }>`
	margin-top: 24px;
	width: 100%;
	text-align: left;

	// TODO: This couples the Form component with the Input component. Its best to attempt to avoid that if possible.
	> div {
		@media (min-width: ${tabletPortraitMinWidth}) {
			width: ${(props) => (props.$singleColumn ? '100%' : 'calc(50% - 10px)')};

			&:nth-child(odd) {
				margin-right: ${(props) => (props.$singleColumn ? '0' : '20px')};
			}
		}
	}
`;
